var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['time_counter_box', {ending: _vm.timerInSeconds <= _vm.timerEndingLimitStartInSeconds }]},[_c('div',{staticClass:"flex-row"},[_c('img',{attrs:{"src":"/static/images/game/timer_icon.svg"}}),_vm._v(" "),_c('div',{staticClass:"time_counter"},[_vm._v("\n      "+_vm._s(_vm._f("formatTimerFilter")(_vm.timerInSeconds))+"\n    ")])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-164a2616","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/game/Timer.vue
// module id = null
// module chunks = 